import { lazy } from 'react'

export const FaqPage = lazy(() => import('./FaqPage'))
